<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2858 8.5332H7.05401C6.10877 8.5332 5.33972 9.42131 5.33972 10.5129V13.0204C5.33972 14.112 6.10877 15.0001 7.05401 15.0001H12.2858C13.2309 15.0001 14 14.112 14 13.0204V10.5129C14 9.42131 13.2309 8.5332 12.2858 8.5332ZM13.2434 13.0204C13.2434 13.6303 12.8138 14.1265 12.2858 14.1265H7.05401C6.52587 14.1265 6.09625 13.6303 6.09625 13.0204V10.513C6.09625 9.90309 6.52587 9.40694 7.05401 9.40694H12.2858C12.8138 9.40694 13.2434 9.90309 13.2434 10.513V13.0204Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M12.2858 1H11.3857C11.1768 1 11.0074 1.19562 11.0074 1.43684C11.0074 1.67807 11.1768 1.87368 11.3857 1.87368H12.2858C12.8138 1.87368 13.2434 2.36985 13.2434 2.97977V5.48715C13.2434 6.09706 12.8138 6.59323 12.2858 6.59323H7.05401C6.52587 6.59323 6.09625 6.09706 6.09625 5.48715V2.97977C6.09625 2.36985 6.52587 1.87368 7.05401 1.87368H8.05288C8.26176 1.87368 8.43115 1.67807 8.43115 1.43684C8.43115 1.19562 8.26176 1 8.05288 1H7.05401C6.10877 1 5.33972 1.88814 5.33972 2.97977V5.48715C5.33972 6.57877 6.10877 7.46691 7.05401 7.46691H12.2858C13.2309 7.46691 14 6.57877 14 5.48715V2.97977C14 1.88814 13.2309 1 12.2858 1Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M7.21436 4.23348C7.21436 4.4747 7.38373 4.67031 7.59261 4.67031H11.7908C11.9997 4.67031 12.1691 4.4747 12.1691 4.23348C12.1691 3.99225 11.9997 3.79663 11.7908 3.79663H7.59261C7.38369 3.79663 7.21436 3.99225 7.21436 4.23348Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M10.1334 11.3296H7.59261C7.38373 11.3296 7.21436 11.5252 7.21436 11.7664C7.21436 12.0077 7.38373 12.2033 7.59261 12.2033H10.1334C10.3422 12.2033 10.5116 12.0077 10.5116 11.7664C10.5116 11.5252 10.3422 11.3296 10.1334 11.3296Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M12.1399 11.5962C12.0102 11.2363 11.5487 11.2472 11.4345 11.6164C11.3804 11.7915 11.4306 11.9936 11.5581 12.1077C11.6814 12.2179 11.8534 12.2298 11.9867 12.1368C12.1449 12.0264 12.2098 11.7931 12.1399 11.5962Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M9.39139 1.60387C9.47075 1.82364 9.69449 1.9315 9.88539 1.8402C10.0758 1.74916 10.1684 1.48924 10.0897 1.26964C10.0108 1.04969 9.78644 0.942491 9.59599 1.03335C9.40588 1.12409 9.31214 1.3844 9.39139 1.60387Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
    <path
      d="M2.85924 10.9996H3.09302L2.74576 11.38C2.61581 11.5223 2.61581 11.753 2.74576 11.8954C2.87299 12.0346 3.08889 12.035 3.21642 11.8954L4.13173 10.8929C4.25928 10.7532 4.25928 10.5172 4.13173 10.3775L3.21642 9.37499C3.08649 9.23275 2.87585 9.23272 2.74576 9.37499C2.61581 9.51731 2.61581 9.74804 2.74576 9.89042L3.09302 10.2707H2.85924C1.776 10.2707 0.894762 9.30564 0.894762 8.11939V6.88021C0.894762 5.69395 1.776 4.72888 2.85924 4.72888H3.89638C4.08015 4.72888 4.22917 4.56569 4.22917 4.36444C4.22917 4.16319 4.08015 4 3.89638 4H2.85924C1.40904 4 0.229198 5.29205 0.229198 6.88021V7.4998V8.11939C0.229198 9.70755 1.40904 10.9996 2.85924 10.9996Z"
      :fill="props.fillColor"
      :stroke="props.fillColor"
      stroke-width="0.4"
    />
  </svg>
</template>
<script setup>
const props = defineProps({
  fillColor: {
    type: String,
    default: "#1B3936",
  },
});
</script>
